'use client';

import Choices from 'components/Choices';
import SupplementalInformation from 'components/SupplementalInformation';

import { ComponentFields } from 'types/content';
import { useAppSelector } from 'lib/hooks';
import { RootState } from 'lib/store';
import Image from 'next/image';

import { selectUserDynamicValues } from 'slices/dynamicDataSelectors';
import { UserDynamicValues } from 'types/user';
import { contentWithData } from 'utils/content';

const SingleQuestionComponent = ({
  data,
  onContinue,
  setCurrentAudioSource,
  setCurrentAudioType,
  setCurrentAudioCaptions,
}: ComponentFields) => {
  const { showClosedCaptions } = useAppSelector(
    (state: RootState) => state.media
  );
  const userData = useAppSelector((state: RootState) =>
    selectUserDynamicValues(state)
  ) as UserDynamicValues;

  const isClosedCaptionShownClass = showClosedCaptions
    ? 'show-captions'
    : 'hide-captions';

  // Get component data
  const art = data.elements.art?.value;
  const choices = data.elements.choices?.value || [];
  const questionLabel = data.elements.question_label?.value;
  const supplementalInformation = data.elements.supplemental_information?.value;

  return (
    <section
      className={`single-question-page ${isClosedCaptionShownClass} ${'flag core'}`}
    >
      <div className="sqp-outer" data-testid="sqp-container">
        {/* TODO: Check if we can delete this */}
        <div className="sqp-left">
          {art && (
            <Image
              alt={art.description || art.url}
              height={art.height || 100}
              src={art.url}
              width={art.width || 100}
            />
          )}
          <div className="supplemental-info">
            {supplementalInformation && (
              <SupplementalInformation
                supplementalInformation={supplementalInformation}
              />
            )}
          </div>
        </div>
        <div className="sqp-content">
          {questionLabel && (
            <div data-testid="sqp-header-text" className="sqp-content-text">
              {contentWithData(questionLabel, userData as UserDynamicValues)}
            </div>
          )}
          <Choices
            choices={choices}
            onContinue={onContinue}
            setCurrentAudioSource={setCurrentAudioSource!}
            setCurrentAudioType={setCurrentAudioType!}
            setCurrentAudioCaptions={setCurrentAudioCaptions!}
          />
        </div>
      </div>
    </section>
  );
};

export default SingleQuestionComponent;
